import Card from './components/card'
import Logo from './components/logo'
import Barcode from './components/barcode'
import Header from './components/header'
import HeroImage from './components/hero-image'
import Fields from './components/fields'

const GoogleEventFront = () => {
  return (
    <Card>
      <Logo/>
      <div className="inset eventTicket">
        <Header />
        <Fields/>
      </div>
      <Barcode/>
      <HeroImage/>
    </Card>
  )
}


export default GoogleEventFront